import React, { FC } from 'react';

import { Box, Button, Card, Flex, Portal, Stack, Transition } from '@mantine/core';

import { EventHelpers } from 'helpers/EventHelpers';

import { useActiveEvents } from 'hooks/use-active-events';
import { useLocalEvent } from 'hooks/use-local-event';
import { useRefreshComponent } from 'hooks/use-refresh-component';
import { EventService } from 'services/EventService';

import cx from './SuggestEventDialog.module.scss';

const SuggestEventDialog: FC = () => {
    const refresh = useRefreshComponent();

    const { localEvent, setLocalEvent } = useLocalEvent();
    const { events } = useActiveEvents();

    const suggestedEvent = events.find(EventHelpers.isHappeningNow);

    const dismissedEventSuggestions = EventService.getDismissedEventSuggestions();
    const dismissed = dismissedEventSuggestions.includes(suggestedEvent?.id);

    return (
        <Portal>
            <Transition
                mounted={!localEvent && !!suggestedEvent && !dismissed}
                transition="slide-up"
                duration={300}
                timingFunction="ease"
            >
                {(style) => (
                    <Box style={style} className={cx.root}>
                        <Card className={cx.inner} p="md">
                            <Stack gap="sm" align="center">
                                <Box className={cx.title}>Are you attending {suggestedEvent?.name}?</Box>
                                <Flex gap="xs">
                                    <Button
                                        size="xs"
                                        onClick={() => {
                                            if (!suggestedEvent?.id) return;
                                            setLocalEvent(suggestedEvent.id);
                                        }}
                                    >
                                        Yes, personalize my experience
                                    </Button>
                                    <Button
                                        size="xs"
                                        variant="subtle"
                                        onClick={() => {
                                            if (!suggestedEvent?.id) return;

                                            EventService.dismissEventSuggestion(suggestedEvent.id);
                                            refresh();
                                        }}
                                    >
                                        Close
                                    </Button>
                                </Flex>
                            </Stack>
                        </Card>
                    </Box>
                )}
            </Transition>
        </Portal>
    );
};

export { SuggestEventDialog };
